'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUser = exports.userNew = exports.USER_NEW = exports.setUserId = exports.USER_ID = exports.tokenValidate = exports.TOKEN_VALIDATE = exports.tokenSent = exports.TOKEN_SENT = exports.tokenSend = exports.TOKEN_SEND = exports.tokenReq = exports.TOKEN_REQ = exports.tokenSet = exports.TOKEN = exports.logout = exports.LOGOUT = exports.login = exports.LOGIN = undefined;
exports.loginRedirect = loginRedirect;

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _capeRedux = require('cape-redux');

var _reduxHistorySync = require('redux-history-sync');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The comment above export defines the expected payload to the action creator.
// No comment, no payload expected.

// User object.
var LOGIN = exports.LOGIN = 'auth/LOGIN';
var login = exports.login = (0, _capeRedux.createAction)(LOGIN);
// Login and redirect.
function loginRedirect(user, destination) {
  if (!destination) throw new Error('loginRedirect requires a user obj and destination str.');
  return function (dispatch) {
    dispatch(login(user));
    dispatch((0, _reduxHistorySync.createHistory)(destination));
  };
}
// Logout the user.
var LOGOUT = exports.LOGOUT = 'auth/LOGOUT';
function logoutMeta() {
  return { cookie: { name: 'sid' } };
}
var logout = exports.logout = (0, _capeRedux.createAction)(LOGOUT, _noop2.default, logoutMeta);

// Set the sid cookie token.
var TOKEN = exports.TOKEN = 'auth/TOKEN_SET';
var tokenSet = exports.tokenSet = (0, _capeRedux.createAction)(TOKEN);
var TOKEN_REQ = exports.TOKEN_REQ = 'auth/TOKEN_REQ';
var tokenReq = exports.tokenReq = (0, _capeRedux.createAction)(TOKEN_REQ);
// Email choice if user has more than one email. Must be associated with account.
var TOKEN_SEND = exports.TOKEN_SEND = 'auth/TOKEN_SEND';
var tokenSend = exports.tokenSend = (0, _capeRedux.createAction)(TOKEN_SEND);
// Email string.
var TOKEN_SENT = exports.TOKEN_SENT = 'auth/TOKEN_SENT';
var tokenSent = exports.tokenSent = (0, _capeRedux.createAction)(TOKEN_SENT);
// Token string.
var TOKEN_VALIDATE = exports.TOKEN_VALIDATE = 'auth/TOKEN_VALIDATE';
var tokenValidate = exports.tokenValidate = (0, _capeRedux.createAction)(TOKEN_VALIDATE);
// User ID string. Sent from server in response to email.
var USER_ID = exports.USER_ID = 'auth/USER_ID';
var setUserId = exports.setUserId = (0, _capeRedux.createAction)(USER_ID);
var USER_NEW = exports.USER_NEW = 'auth/USER_NEW';
var userNew = exports.userNew = (0, _capeRedux.createAction)(USER_NEW);
var setUser = exports.setUser = userNew;


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-auth/lib/actions.js
// module id = 356
// module chunks = 0